
// Hari K:06-11-2023 :BT-119138:Funds View - Transaction modal - start
import { memo, useEffect, useState } from "react";
import { BzButton, BzChip, BzDateRangePicker, BzLoader, BzModal, BzModalBody, BzModalHeader } from "../../components";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { handleModal } from "../../redux/actions/modals";
import { getFundsReport } from "../../redux/actions/funds";
import TransactionFilterModal from "./TransactionFilterModal";
import ZeroStates from "../ZeroStates";
import { _commaFormatter, _kFormatter } from "../../controllers";
import TransactionDetailsModal from "./TransactionDetailsModal";


const TransactionModal = ({ startDate, endDate, setStartDate, setEndDate }) => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state.modals.modals);
    const transactionListGrid = useSelector(state => state.funds.transactionListGrid);
    const isTransactionAPI = useSelector(state => state.funds.isTransactionAPI);
    const isTransactionPending = useSelector(state => state.funds.isTransactionPending);

    const [filterInputs, setFilterInputs] = useState({ minAmount: '', maxAmount: '', funds: '' });
    const [finalFilterInputs, setFinalFilterInputs] = useState({ minAmount: '', maxAmount: '', funds: '' });
    const [selectedRange, setSelectedRange] = useState([]);
    const [isPickerOpen, setIsPickerOpen] = useState(false);
    const [arrTransactionData, setArrTransactionData] = useState([]);

    useEffect(() => {
        let filterTransactionsData = transactionListGrid;
        if (Object.values(finalFilterInputs).some((value) => value !== '')) {
            if (finalFilterInputs?.hasOwnProperty('type')) {
                filterTransactionsData = filterTransactionsData?.filter((each) => each.type === finalFilterInputs?.type);
            } else { }
            if (finalFilterInputs?.minAmount && finalFilterInputs?.maxAmount) {
                filterTransactionsData = filterTransactionsData?.filter((each) => (each?.nAmount >= finalFilterInputs?.minAmount && each?.nAmount <= finalFilterInputs?.maxAmount));
            } else if ((finalFilterInputs?.minAmount?.length === 0 || finalFilterInputs?.minAmount?.length === undefined) && finalFilterInputs?.maxAmount) {
                filterTransactionsData = filterTransactionsData?.filter((each) => (each?.nAmount >= 0 && each?.nAmount <= finalFilterInputs?.maxAmount));
            } else if ((finalFilterInputs?.maxAmount?.length === 0 || finalFilterInputs?.maxAmount?.length === undefined) && finalFilterInputs?.minAmount) {
                filterTransactionsData = filterTransactionsData?.filter((each) => (each?.nAmount >= finalFilterInputs?.minAmount));
            }
            setArrTransactionData(filterTransactionsData);
        } else {
            setArrTransactionData(transactionListGrid);
        }
    }, [transactionListGrid, finalFilterInputs]);

    const onHide = () => {
        setIsPickerOpen(false);
        dispatch(handleModal([{ "TRANSACTION_MODAL": false }]));
        setStartDate(dayjs().format('MM-DD-YYYY'));
        setEndDate(dayjs().format('MM-DD-YYYY'));
        setSelectedRange([dayjs(), dayjs()]);
        setFilterInputs({ minAmount: '', maxAmount: '', funds: '' });
        setFinalFilterInputs({ minAmount: '', maxAmount: '', funds: '' });
    };

    const handleDateChange = (dates) => {
        setStartDate(dates[0]?.format('MM-DD-YYYY'));
        setEndDate(dates[1]?.format('MM-DD-YYYY'));
        setSelectedRange(dates);
        setIsPickerOpen(true);
    };

    const today = dayjs();
    const thisMonthStart = today.startOf('month');
    const lastDay = today.subtract(1, 'day');
    const last7Days = [today.subtract(6, 'day'), today];
    const last30Days = [today.subtract(29, 'day'), today];
    const thisMonth = [thisMonthStart, today];
    const lastMonth = [
        today.subtract(1, 'month').startOf('month'),
        today.subtract(1, 'month').endOf('month'),
    ];

    const presets = {
        Today: [today, today],
        'Yesterday': [lastDay, lastDay],
        'Last 7 Days': last7Days,
        'Last 30 Days': last30Days,
        'This Month': thisMonth,
        'Last Month': lastMonth,
        'Custom Range': [], // Empty range for the custom range preset
    };

    useEffect(() => {
        setSelectedRange([today, today]);
        setIsPickerOpen(false);
    }, []);

    const handleApply = () => {
        setIsPickerOpen(false);
        // const dates = selectedRange.map((date) => date.startOf('day'));
        dispatch(getFundsReport(startDate, endDate));
    };

    const handlePanelChange = (dates) => {
        if ((dates && (dates[0] && dates[0].isAfter(dayjs().endOf('day')))) && (dates && dates[1] && dates[1].isAfter(dayjs().endOf('day')))) {
            setSelectedRange(null);
        }
        if (dates && (dates[0] && dates[0].isAfter(dayjs().endOf('day')))) {
            setSelectedRange([null, dates[1]]);
        } if (dates && dates[1] && dates[1].isAfter(dayjs().endOf('day'))) {
            setSelectedRange([dates[0], null]);
        } else {
            if (dates[0]) {
                setStartDate(dates[0].format('MM-DD-YYYY'));
                setIsPickerOpen(true);
            } else if (dates[1]) {
                setEndDate(dates[1].format('MM-DD-YYYY'));
            }
            setSelectedRange(dates);

        }
    };


    const handleCancel = () => {
        setIsPickerOpen(false);
    };

    const renderExtraFooter = () => {
        const startDate = selectedRange && selectedRange[0]?.format('MMMM D, YYYY');
        const endDate = selectedRange && selectedRange[1]?.format('MMMM D, YYYY');
        const selectedDatesText = startDate && endDate ? `${startDate} - ${endDate}` : '';

        return (
            /*SumitG-08-12-23*/
            <Container fluid className='p-0'>
                <Row className='g-0 py-2'>
                    <div className='d-flex align-items-center'>
                        <Col md='auto'>&nbsp;</Col>
                        <Col md={6} className='d-flex justify-content-end align-items-center text-end me-2 ms-auto'>
                            <div className='font-regular font-size2 color-text'>{selectedDatesText}</div>
                        </Col>
                        <Col md='auto' className='d-flex justify-content-end align-items-center text-end'>
                            <BzButton data-testid="date-range-picker-date-cancel-button" className='btn btn-sm btn-outline me-2' onClick={handleCancel}>Cancel</BzButton>
                            <BzButton data-testid="date-range-picker-date-apply-button" className='btn btn-sm btn-primary me-2' onClick={handleApply}>Apply</BzButton>
                        </Col>
                    </div>
                </Row>
            </Container>
        );
    };

    const handleFilterIcon = () => {
        dispatch(handleModal([{ "TRANSACTION_FILTER_MODAL": true }]));
    };

    const handleDelete = (itemToDelete) => {
        if ((Object.values(filterInputs)?.length === 1)) {
            setArrTransactionData(transactionListGrid);
        }
        let updatedObj = { ...filterInputs };
        if (itemToDelete === "minAmount") {
            delete updatedObj["minAmount"];
            delete updatedObj["maxAmount"];
        } else {
            delete updatedObj[itemToDelete];
        }
        setFilterInputs(updatedObj);
        setFinalFilterInputs(updatedObj);
    };

    const handleKeyDown = (e) => { // Hari k:2023-12-20 added function for user enter only numbers
        // Allow only numeric characters and certain control keys (e.g., Backspace, Arrow keys)
        if (!/^\d$/.test(e.key) && e.key.length === 1 && e.key !== '-' && !e.ctrlKey) {
            e.preventDefault();
        }
    };

    const [selectedTransaction, setSelectedTransaction] = useState({});
    const handleTransaction = (each) => {
        setSelectedTransaction(each);
        dispatch(handleModal([{ "TRANSACTION_DETAILS_MODAL": true }]));
    };
    const disableFutureDates = (current) => {
        return current && current > dayjs().endOf('day');
    };
    const [selectedDates, setSelectedDates] = useState([]);
    const handleCalendarChange = (dates) => {
        if (dates && (dates[0] && dates[0].isAfter(dayjs().endOf('day')) || dates[1] && dates[1].isAfter(dayjs().endOf('day')))) {
            setSelectedRange([]);
        } else { setSelectedRange(dates); }
    };
    return (
        <>
            {/* SumitG-08-12-23 */}
            <BzModal show={modals['TRANSACTION_MODAL']} onHide={onHide} className='modal-breeze' data-testid="funds-transaction-modal">
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={11} className='d-flex justify-content-start align-self-center'>
                                <div data-testid='funds-transaction-modal-title' className='font-medium font-size4 color-text'>Recent Transactions</div>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-self-center'>
                                <div data-testid='funds-transaction-modal-close-icon' className='icon-16 icon-close icon-dark' onClick={onHide}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <Container fluid className='p-0 px-3'>
                    <Row className='g-0 my-2'>
                        <div className='d-flex align-items-center'>
                            <Col md={11} className='d-flex justify-content-end align-items-center'>
                                <div className='datepicker-wrap' data-testid='funds-transaction-modal-date-range-picker'>
                                    {modals['TRANSACTION_MODAL'] ?
                                        <BzDateRangePicker  selectedDates={selectedDates} handleCalendarChange={handleCalendarChange} className='custom-date-range-picker form-datepicker-primary form-control font-medium py-1 px-2 d-flex' disableFutureDates={disableFutureDates} handleKeyDown={handleKeyDown} handlePanelChange={handlePanelChange} handleCancel={handleCancel} renderExtraFooter={renderExtraFooter} handleDateChange={handleDateChange} presets={presets} isPickerOpen={isPickerOpen} selectedRange={selectedRange} setSelectedRange={setSelectedRange} setIsPickerOpen={setIsPickerOpen} />
                                        : null}
                                </div>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-items-center'>
                                <div data-testid='funds-transaction-modal-filter-icon' className='icon-16 icon-searchfilter icon-dark' onClick={() => handleFilterIcon()}></div>
                            </Col>
                        </div>
                    </Row>
                </Container>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col>
                                {Object.values(finalFilterInputs).some((value) => value !== '') ?
                                    <div className='d-flex align-items-center' data-testid='funds-transaction-modal-filters'>
                                        <div className='font-medium font-size2 color-text me-2'>Filters:</div>
                                        <div className='horizontal-scroll-wrap py-1'>
                                            <div className='filters-chips-wrap flex-nowrap'>
                                                {finalFilterInputs?.type ?
                                                    <BzChip data-testid='funds-transaction-modal-filters-type' key={finalFilterInputs?.type} className='filter-chip me-1 text-capitalize'>Funds: {finalFilterInputs?.type == 'A' ? 'Add' : finalFilterInputs?.type == 'AL' ? 'Transferred' : finalFilterInputs?.type == "W" ? 'Withdrawal' : null}
                                                        <div data-testid='funds-transaction-modal-filters-type-close-icon' onClick={() => handleDelete("type")} className='icon-10 icon-close icon-dark ms-2'></div></BzChip>
                                                    : null}
                                                {(finalFilterInputs?.maxAmount?.length && finalFilterInputs?.minAmount?.length) ?
                                                    <BzChip data-testid='funds-transaction-modal-filters-amount' className='filter-chip me-1 text-capitalize'>Amount:  Min &#8377;{finalFilterInputs?.minAmount} -  Max &#8377;{finalFilterInputs?.maxAmount}
                                                        <div data-testid='funds-transaction-modal-filters-amount-close-icon' onClick={() => handleDelete("minAmount")} className='icon-10 icon-close icon-dark ms-2'></div></BzChip>
                                                    : ((finalFilterInputs?.maxAmount?.length === 0 || finalFilterInputs?.maxAmount?.length === undefined) && finalFilterInputs?.minAmount?.length) ?
                                                        <BzChip data-testid='funds-transaction-modal-filters-min-amount' className='filter-chip me-1 text-capitalize'>Amount:  Min &#8377;{finalFilterInputs?.minAmount}
                                                            <div data-testid='funds-transaction-modal-filters-min-amount-close-icon' onClick={() => handleDelete("minAmount")} className='icon-10 icon-close icon-dark ms-2'></div></BzChip>
                                                        :
                                                        (finalFilterInputs?.maxAmount?.length && (finalFilterInputs?.minAmount?.length === 0 || finalFilterInputs?.minAmount?.length === undefined)) ?
                                                            <BzChip data-testid='funds-transaction-modal-filters-max-amount' className='filter-chip me-1 text-capitalize'>Amount: Max &#8377;{finalFilterInputs?.maxAmount}
                                                                <div data-testid='funds-transaction-modal-filters-max-amount-close-icon' onClick={() => handleDelete("minAmount")} className='icon-10 icon-close icon-dark ms-2'></div></BzChip>
                                                            : null}
                                            </div>
                                        </div>
                                    </div>
                                    : null
                                }
                            </Col>
                        </Row>
                        {arrTransactionData?.length && isTransactionPending === false ?
                            arrTransactionData?.map((each) => (
                                <div data-testid='funds-transaction-modal-transaction' className='py-3 bdr-btm' onClick={() => handleTransaction(each)}>
                                    <Row className='g-0'>
                                        <Col md={9} className='d-flex justify-content-start'>
                                            <Container fluid className='p-0'>
                                                <Row className='g-0'>
                                                    <Col className='d-flex justify-content-start align-items-start'>
                                                        <div data-testid='funds-transaction-modal-transaction-type' className='font-regular font-size3 color-text'>
                                                            {each.type === "AL" ?
                                                                <>
                                                                    <span className='font-medium'>Transferred</span> to
                                                                </>
                                                                : each.type === "W" ?
                                                                    <>
                                                                        <span className='font-medium'>Withdrawal</span> from
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <span className='font-medium'>Added</span> to
                                                                    </>}
                                                            <span className='ms-1'>{each.sProductName}</span></div>
                                                    </Col>
                                                </Row>
                                                <Row className='g-0 mt-1'>
                                                    <Col className='d-flex justify-content-start align-items-center'>
                                                        {each.sBankName?.length ?
                                                            <div className='chips-wrap'>
                                                                <BzChip data-testid='funds-transaction-modal-transaction-bank-name' className='chips primary-chip text-uppercase me-2'>{each.sBankName}</BzChip>
                                                            </div> : null}
                                                        <div className='font-regular font-size1 color-subtext'>{each.DispDateTime}</div>
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </Col>
                                        <Col md={3} className='d-flex justify-content-end text-end'>
                                            <Container fluid className='p-0'>
                                                <Row className='g-0'>
                                                    <Col className='d-flex justify-content-end'>
                                                        <div data-testid='funds-transaction-modal-transaction-amount' className={`font-medium font-size3 color-text ${each.type === "W" ? "color-negative" : 'color-positive'}`}>{each.type === "W" ? "-" : "+"} ₹ {_commaFormatter(_kFormatter(parseFloat(each.nAmount)))}</div>
                                                    </Col>
                                                </Row>
                                                <Row className='g-0 mt-1'>
                                                    <Col className='d-flex justify-content-end'>
                                                        {each?.Status?.length ?
                                                            <div className='chips-wrap mt-1'>
                                                                <BzChip
                                                                    data-testid='funds-transaction-modal-transaction-status'
                                                                    className={
                                                                        `chips text-uppercase ${each.Status?.toUpperCase() === "PENDING"
                                                                            ? 'warning-chip'
                                                                            : each.Status?.toUpperCase() === "CANCELLED"
                                                                                || each.Status === "1"
                                                                                ? 'negative-chip'
                                                                                : 'positive-chip'
                                                                        }`
                                                                    }
                                                                >
                                                                    {
                                                                        each.Status === "PENDING"
                                                                            ? "PENDING"
                                                                            : each.Status === "0"
                                                                                ? "SUCCESS"
                                                                                : each.Status?.toUpperCase() === "CANCELLED"
                                                                                    ? "Cancelled"
                                                                                    : each.Status?.toUpperCase() === "ACCEPTED"
                                                                                        ? "Accepted"
                                                                                        : each.Status === "1"
                                                                                            ? "FAILED"
                                                                                            : null
                                                                    }
                                                                </BzChip>

                                                            </div> : null}
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </Col>
                                    </Row>
                                </div>
                            )) : (Object.values(finalFilterInputs).some((value) => value !== '') && arrTransactionData?.length <= 0) || (isTransactionAPI === false && arrTransactionData?.length <= 0 && isTransactionPending === false) ?
                                <div className='zero-state-alerts zero-state-alerts-lg'>
                                    <ZeroStates heading="No Transactions Available" isButtonShowing={false} icon='icon-64 icon-nodata mb-3 mrgauto' />
                                </div>
                                : isTransactionAPI ?
                                    <div className='zero-state-alerts zero-state-alerts-lg'>
                                        <ZeroStates subText="Uh oh! Looks like we missed something." isButtonShowing={false} icon='icon-64 icon-missed-something mb-3 mrgauto' />
                                        <div className='font-regular font-size2 color-nodata text-center'>Let us fix the problem and get back to you soon</div>
                                    </div>
                                    : isTransactionPending ?
                                        <div className='zero-state-loader-alerts zero-state-loader-alert-lg'>
                                            <BzLoader spinner={isTransactionPending} spinnerContent={"Fetching Details"} bIsFfromModal={true} />
                                        </div>
                                        : null}
                    </Container>
                </BzModalBody>
            </BzModal>
            <TransactionDetailsModal transactionDetails={selectedTransaction} />
            <TransactionFilterModal finalFilterInputs={finalFilterInputs} setFinalFilterInputs={setFinalFilterInputs} filterInputs={filterInputs} setFilterInputs={setFilterInputs} />
        </>
    );
};

export default memo(TransactionModal);
// Hari K:06-11-2023 :BT-119138:Funds View - transaction - end